import React from 'react';
import Footer from '../components/Footer';

const AboutUs: React.FC = () => (
  <div className="max-w-2xl mx-auto py-12 px-4 text-center pb-20">
    <h1 className="text-3xl font-bold mb-4 text-primary">About ArtistDesk</h1>
    <p className="text-lg text-secondary mb-6">
      ArtistDesk is a modern platform for makeup artists and clients to connect, book appointments, and manage services with ease. Our mission is to empower artists and simplify the booking experience for everyone.
    </p>
    <div className="bg-white rounded-lg shadow p-6">
      <h2 className="text-xl font-semibold mb-2 text-primary">Our Story</h2>
      <p className="text-secondary">
        Founded in 2025, ArtistDesk brings together technology and creativity to help artists grow their business and clients find the perfect look for every occasion.
      </p>
    </div>
    <Footer />
  </div>
);

export default AboutUs;
